import { useEffect } from "react";

export const useHideOverflow = (dependency, trigger) => {
    useEffect(() => {
        if (trigger) {document.body.style.overflow = "hidden";} else {document.body.style.overflow = "auto";}
        return () => {document.body.style.overflow = "auto";};
    }, [dependency]);
};
